module.exports = __webpack_public_path__ + "img/image28.a3504e31.png";